import React, { Component } from "react";
import { message, PageHeader, Spin, Upload, Alert, Switch, Tag, Modal, Select, Progress } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import {
  TableItem,
  ButtonItem,
  InputItem,
  InputNumberItem,
  SelectItem,
  dineroDisabledMask,
} from "../../../../Components/Items";
import SelectInsumosItem from "../../../../Components/SelectInsumosItem";
import ModalSeleccionMultipleInsumos from "../../../../Components/ModalSeleccionMultipleInsumos";
import {
  ETIQUETAS_ESTADO_CLAVE,
  descargarPlantillaInsumosCliente,
  esArchivoExcel,
  leerFilasExcelInsumosCliente,
  normalizar,
  resolverUnidadesDeFilas,
} from "../../../../Components/excelInsumosCliente";
import { precioIdDeCliente, precioDeLista } from "../../../../Components/precioListaCliente";
import {
  UploadOutlined,
  DownloadOutlined,
  DeleteOutlined,
  UndoOutlined,
  SaveOutlined,
  PlusOutlined,
  EditOutlined,
} from "@ant-design/icons";

const { Option } = Select;

// Las 5 columnas que editarInsumosPersonalizadosClienteMasivo acepta. `conversion` no
// esta en su whitelist (esta fija en 1 en toda la UI), asi que no se compara ni se manda.
const COLUMNAS_MASIVO = ["Nombre para el Cliente", "Clave Cliente", "Precio Unitario", "Unidad", "Presentación"];

// El endpoint tope es de 1000 filas por peticion (LIMITE_FILAS_EXCEL_VENTA)
const LOTE_RESOLUCION_EXCEL = 200;
const LIMITE_ALTAS_POR_ENVIO = 2000;

const textoLimpio = (valor) => String(valor ?? "").trim();

const estaVacio = (valor) => valor === undefined || valor === null || valor === "";

const mismoTexto = (a, b) => textoLimpio(a) === textoLimpio(b);

const mismoNumero = (a, b) => {
  if (estaVacio(a) && estaVacio(b)) return true;
  if (estaVacio(a) || estaVacio(b)) return false;
  return Number(a) === Number(b);
};

class CapturaInsumosCliente extends Component {
  constructor(props) {
    super(props);
    // location.state se lee UNA sola vez: un history.replace posterior lo borraria
    this.state = {
      loading: false,
      guardando: false,
      clienteId: this.props.location.state?.clienteId,
      clienteNombre: this.props.location.state?.clienteNombre || "",
      cliente: null,
      contado: 1,
      precioId: null,
      listasPrecios: [],
      opcionesUnidades: [],
      filas: [],
      originales: {},
      insumoIdsTomados: new Set(),
      identidadesRepetidas: new Set(),
      soloModificados: false,
      erroresBackend: [],
      keysConError: new Set(),
      archivosExcel: [],
      procesandoExcel: false,
      progresoExcel: null,
      modalVariosVisible: false,
      descargandoPlantilla: false,
    };

    this.contadorFilas = 0;
    // Identidad estable: si estas funciones se crearan inline en el render, memoizar la
    // fila no serviria de nada (cada render pasaria props nuevas)
    this.funciones = {
      actualizarFila: this.actualizarFila.bind(this),
      alternarEliminada: this.alternarEliminada.bind(this),
      onChangeInsumo: this.onChangeInsumo.bind(this),
      editarInsumo: this.editarInsumo.bind(this),
      elegirCandidato: this.elegirCandidato.bind(this),
    };
  }

  componentDidMount() {
    if (!this.state.clienteId) {
      message.error("No se encontró el cliente");
      this.salir();
      return;
    }
    if (!this.props.insumosXCliente) {
      message.warning("La empresa no tiene activado el módulo de Insumos por Cliente");
      this.salir();
      return;
    }
    this.cargarTodo();

    // Bloquear la salida con cambios sin guardar. EdicionMasivaInsumosCliente no lo
    // tiene; aqui una navegacion accidental tira una captura de cientos de renglones.
    this.desbloquear = this.props.history.block(() =>
      this.hayCambios() ? "Hay cambios sin guardar. ¿Seguro que quieres salir?" : undefined
    );
    window.addEventListener("beforeunload", this.avisarAlCerrar);
  }

  componentWillUnmount() {
    if (this.desbloquear) this.desbloquear();
    window.removeEventListener("beforeunload", this.avisarAlCerrar);
  }

  avisarAlCerrar = (e) => {
    if (!this.hayCambios()) return undefined;
    e.preventDefault();
    e.returnValue = "";
    return "";
  };

  // goBack() se queda pegado si se entro por URL directa o tras recargar (no hay
  // entrada previa en el historial), y saca al usuario del ERP
  salir() {
    if (this.props.history.length <= 1) this.props.history.replace("/panel/clientes");
    else this.props.history.goBack();
  }

  atras = () => {
    this.salir();
  };

  cargarTodo() {
    this.setState({ loading: true });
    Promise.all([
      axios.post(
        "clientes/buscarCliente",
        { empresaId: this.props.empresaId, clienteId: this.state.clienteId },
        { headers: this.props.headersToken }
      ),
      axios.post("unidades/selectUnidades", { empresaId: this.props.empresaId }, { headers: this.props.headersToken }),
      axios.post("empresas/selectPrecios", { empresaId: this.props.empresaId }, { headers: this.props.headersToken }),
      axios.post(
        "insumosCliente/selectInsumosPersonalizadosCliente",
        { empresaId: this.props.empresaId, clienteId: this.state.clienteId, page: 1, pageSize: 100000 },
        { headers: this.props.headersToken }
      ),
    ])
      .then(([resCliente, resUnidades, resPrecios, resInsumos]) => {
        if (resCliente.data.success !== 2 || !resCliente.data.cliente) {
          message.error(resCliente.data.message || "No se encontró el cliente");
          this.setState({ loading: false });
          this.salir();
          return;
        }
        const cliente = resCliente.data.cliente;
        const opcionesUnidades = (Array.isArray(resUnidades.data) ? resUnidades.data : [])
          .filter((unidad) => unidad?.unidadSat?.c_ClaveUnidad)
          .map((unidad) => ({ value: unidad._id, label: `${unidad.unidadSat.c_ClaveUnidad} - ${unidad.nombre}` }));

        this.setState(
          {
            cliente,
            clienteNombre: this.state.clienteNombre || cliente.stringBuscar || "",
            opcionesUnidades,
            listasPrecios: Array.isArray(resPrecios.data) ? resPrecios.data : [],
            precioId: precioIdDeCliente(cliente, this.state.contado),
            loading: false,
          },
          () => this.aplicarInsumos(resInsumos.data)
        );
      })
      .catch(() => {
        message.error("No se pudo cargar la información del cliente");
        this.setState({ loading: false });
      });
  }

  recargar() {
    this.setState({ loading: true });
    return axios
      .post(
        "insumosCliente/selectInsumosPersonalizadosCliente",
        { empresaId: this.props.empresaId, clienteId: this.state.clienteId, page: 1, pageSize: 100000 },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.aplicarInsumos(res.data);
        this.setState({ loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  }

  aplicarInsumos(data) {
    if (data?.success !== 2) {
      this.setState({ loading: false });
      return;
    }
    const originales = {};
    const filas = (data.data || []).map((item) => {
      const id = String(item._id);
      originales[id] = {
        nombreAlternativo: item.nombreAlternativo,
        clave: item.clave,
        precio: item.precio,
        unidadId: item.unidadId ? String(item.unidadId) : undefined,
        presentacion: item.presentacion,
      };
      return {
        _key: `e_${id}`,
        _id: id,
        _origen: "existente",
        _claveInterna: item.claveInterna,
        _descripcion: item.descripcion,
        _stringBuscar: [item.claveInterna, item.descripcion, item.unidadNombre].filter(Boolean).join(" - "),
        insumoId: String(item.insumoId),
        equivalenciaId: item.equivalenciaId ? String(item.equivalenciaId) : undefined,
        nombreAlternativo: item.nombreAlternativo,
        clave: item.clave,
        precio: item.precio,
        presentacion: item.presentacion,
        unidadId: item.unidadId ? String(item.unidadId) : undefined,
        conversion: item.conversion || 1,
      };
    });

    this.setState({
      filas,
      originales,
      ...this.calcularIndices(filas),
      erroresBackend: [],
      keysConError: new Set(),
    });
  }

  // Sets nuevos sólo cuando de verdad cambia el conjunto: se pasan por referencia a cada
  // fila, así que recrearlos en cada render anularía cualquier memoización.
  // `insumoIdsTomados` son las identidades que ya están en la tabla (para avisar al
  // agregar) y `identidadesRepetidas` las que están en más de un renglón vivo (para
  // marcarlos): repetir un insumo está permitido, pero tiene que verse.
  calcularIndices(filas) {
    const conteo = new Map();
    filas
      .filter((fila) => !fila._eliminado && fila.insumoId)
      .forEach((fila) => {
        const identidad = String(fila.equivalenciaId || fila.insumoId);
        conteo.set(identidad, (conteo.get(identidad) || 0) + 1);
      });
    return {
      insumoIdsTomados: new Set(conteo.keys()),
      identidadesRepetidas: new Set([...conteo.entries()].filter(([, veces]) => veces > 1).map(([id]) => id)),
    };
  }

  // ---------- construcción de renglones ----------

  nuevaKey() {
    this.contadorFilas += 1;
    return `n_${this.contadorFilas}`;
  }

  construirFilaDesdeInsumo(insumo, valoresDelArchivo = {}) {
    const precioLista = precioDeLista(insumo, this.state.precioId);
    const traeArchivo = (campo) => !estaVacio(valoresDelArchivo[campo]);
    const insumoIdPrincipal = insumo.noPrincipal ? insumo.insumoPrincipalId : insumo._id;
    return {
      _key: this.nuevaKey(),
      _id: undefined,
      _origen: valoresDelArchivo._origen || "manual",
      _claveInterna: insumo.clave,
      _descripcion: insumo.descripcion,
      _stringBuscar: insumo.stringBuscar || `${insumo.clave || ""} - ${insumo.descripcion || ""}`,
      _precioLista: precioLista,
      _sinPrecioLista: precioLista === undefined,
      _precioTocado: traeArchivo("precio"),
      insumoId: String(insumoIdPrincipal),
      equivalenciaId: insumo.noPrincipal ? String(insumo._id) : undefined,
      // El nombre y la clave del catálogo son el punto de partida; el usuario cambia
      // sólo lo que el contrato diga distinto
      nombreAlternativo: traeArchivo("nombreAlternativo") ? valoresDelArchivo.nombreAlternativo : insumo.descripcion,
      clave: traeArchivo("clave") ? valoresDelArchivo.clave : insumo.clave,
      precio: traeArchivo("precio") ? valoresDelArchivo.precio : precioLista,
      presentacion: traeArchivo("presentacion") ? valoresDelArchivo.presentacion : undefined,
      unidadId: traeArchivo("unidadId")
        ? valoresDelArchivo.unidadId
        : insumo.unidadId
        ? String(insumo.unidadId)
        : undefined,
      conversion: 1,
    };
  }

  // ---------- agregar ----------

  agregarFilaDesdeInsumo = (insumoId, insumo) => {
    if (!insumoId || !insumo) return;
    // Repetir un insumo está permitido: el mismo insumo puede necesitar varios renglones
    // (otra clave del cliente, otra presentación, otro precio de contrato). Sólo se avisa.
    const identidad = insumo.noPrincipal ? insumo._id : insumoId;
    if (this.state.insumoIdsTomados.has(String(identidad))) {
      message.warning("Ese insumo ya está en la lista: se agregó otro renglón aparte.");
    }
    const fila = this.construirFilaDesdeInsumo(insumo);
    this.setState((prev) => {
      const filas = [fila, ...prev.filas];
      return { filas, ...this.calcularIndices(filas) };
    });
  };

  agregarVarios = (insumos) => {
    const tomados = this.state.insumoIdsTomados;
    // Ninguno se descarta: los que ya estaban entran como renglón aparte y sólo se avisa
    const repetidos = insumos.filter((insumo) => tomados.has(String(insumo._id))).length;
    const nuevas = insumos.map((insumo) => this.construirFilaDesdeInsumo(insumo));
    if (nuevas.length === 0) {
      this.setState({ modalVariosVisible: false });
      return;
    }
    this.setState(
      (prev) => {
        const filas = [...nuevas, ...prev.filas];
        return { filas, ...this.calcularIndices(filas), modalVariosVisible: false };
      },
      () =>
        message.success(
          `Se agregaron ${nuevas.length} renglón(es)` +
            (repetidos > 0 ? `, ${repetidos} de insumos que ya estaban en la lista.` : ".")
        )
    );
  };

  // ---------- edición de celdas ----------

  actualizarFila(key, cambios) {
    this.setState((prev) => {
      const filas = prev.filas.map((fila) => (fila._key === key ? { ...fila, ...cambios } : fila));
      const cambiaInsumo = Object.prototype.hasOwnProperty.call(cambios, "insumoId");
      return {
        filas,
        ...(cambiaInsumo ? { ...this.calcularIndices(filas) } : {}),
      };
    });
  }

  alternarEliminada(key) {
    this.setState((prev) => {
      const fila = prev.filas.find((item) => item._key === key);
      if (!fila) return null;
      // Un renglón nuevo se quita y ya; uno existente se marca para borrar al Guardar
      const filas = fila._id
        ? prev.filas.map((item) => (item._key === key ? { ...item, _eliminado: !item._eliminado } : item))
        : prev.filas.filter((item) => item._key !== key);
      return { filas, ...this.calcularIndices(filas) };
    });
  }

  editarInsumo(key) {
    this.actualizarFila(key, { _editandoInsumo: true });
  }

  // Salida rápida para los renglones que el Excel no pudo empatar: bloquean el guardado
  // y borrarlos de uno en uno sería un castigo por importar un archivo imperfecto
  quitarSinInsumo = () => {
    this.setState((prev) => {
      const filas = prev.filas.filter((fila) => fila.insumoId || fila._eliminado);
      return { filas, ...this.calcularIndices(filas) };
    });
  };

  onChangeInsumo(key, insumoId, insumo) {
    const identidad = insumo?.noPrincipal ? insumo._id : insumoId;
    const filaActual = this.state.filas.find((fila) => fila._key === key);
    const identidadActual = filaActual ? String(filaActual.equivalenciaId || filaActual.insumoId || "") : "";
    // Se permite dejar el mismo insumo en dos renglones; el renglón queda marcado en la tabla
    if (identidad && String(identidad) !== identidadActual && this.state.insumoIdsTomados.has(String(identidad))) {
      message.warning("Ese insumo ya está en otro renglón de la lista.");
    }
    const insumoIdPrincipal = insumo?.noPrincipal ? insumo.insumoPrincipalId : insumoId;
    const equivalenciaId = insumo?.noPrincipal ? insumo._id : undefined;
    const precioLista = insumo ? precioDeLista(insumo, this.state.precioId) : undefined;
    this.setState((prev) => {
      const filas = prev.filas.map((fila) => {
        if (fila._key !== key) return fila;
        // Sólo se rellena lo que esté vacío: un renglón que vino del Excel no debe
        // perder el nombre o el precio que traía el archivo
        return {
          ...fila,
          insumoId: insumoIdPrincipal ? String(insumoIdPrincipal) : undefined,
          equivalenciaId: equivalenciaId ? String(equivalenciaId) : undefined,
          _claveInterna: insumo?.clave,
          _descripcion: insumo?.descripcion,
          _stringBuscar: insumo?.stringBuscar,
          _estadoClave: undefined,
          _candidatos: undefined,
          _editandoInsumo: false,
          _precioLista: precioLista,
          _sinPrecioLista: precioLista === undefined,
          nombreAlternativo: estaVacio(fila.nombreAlternativo) ? insumo?.descripcion : fila.nombreAlternativo,
          clave: estaVacio(fila.clave) ? insumo?.clave : fila.clave,
          precio: estaVacio(fila.precio) ? precioLista : fila.precio,
          unidadId: estaVacio(fila.unidadId) ? (insumo?.unidadId ? String(insumo.unidadId) : undefined) : fila.unidadId,
        };
      });
      return { filas, ...this.calcularIndices(filas) };
    });
  }

  // Los candidatos de un AMBIGUO vienen en forma ligera (sin precios[]), así que se
  // pide el insumo completo para poder precargar el precio de lista
  elegirCandidato(key, insumoId) {
    if (!insumoId) return;
    axios
      .post(
        "insumos/selectInsumosPorIds",
        { empresaId: this.props.empresaId, insumoIds: [insumoId] },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        const insumo = res.data?.success === 2 ? (res.data.insumos || [])[0] : null;
        if (!insumo) return message.warning("No se pudo cargar ese insumo");
        this.onChangeInsumo(key, insumoId, insumo);
      })
      .catch(() => message.warning("No se pudo cargar ese insumo"));
  }

  // Cambiar de lista NO repinta los precios ya capturados: un renglón existente lleva un
  // precio de contrato pactado y uno nuevo puede haberse tecleado a mano. Sólo cambia de
  // dónde salen los precios de los renglones que se agreguen a partir de aquí.
  onChangeContado = (contado) => {
    this.setState({ contado, precioId: precioIdDeCliente(this.state.cliente, contado) });
    message.info("Los renglones que agregues de ahora en adelante usarán esa lista.");
  };

  // ---------- diff ----------

  camposCambiados(fila) {
    if (!fila._id) return [];
    const original = this.state.originales[fila._id];
    if (!original) return [];
    const cambios = [];
    if (!mismoTexto(fila.nombreAlternativo, original.nombreAlternativo)) cambios.push("nombreAlternativo");
    if (!mismoTexto(fila.clave, original.clave)) cambios.push("clave");
    if (!mismoNumero(fila.precio, original.precio)) cambios.push("precio");
    if (!mismoTexto(fila.unidadId, original.unidadId)) cambios.push("unidadId");
    if (!mismoTexto(fila.presentacion, original.presentacion)) cambios.push("presentacion");
    return cambios;
  }

  filaModificada(fila) {
    return this.camposCambiados(fila).length > 0;
  }

  hayCambios() {
    return this.state.filas.some((fila) => !fila._id || fila._eliminado || this.filaModificada(fila));
  }

  resumen() {
    const { filas } = this.state;
    const vivas = filas.filter((fila) => !fila._eliminado);
    return {
      nuevas: vivas.filter((fila) => !fila._id).length,
      editadas: vivas.filter((fila) => fila._id && this.filaModificada(fila)).length,
      eliminadas: filas.filter((fila) => fila._eliminado && fila._id).length,
      sinInsumo: vivas.filter((fila) => !fila.insumoId).length,
      total: vivas.length,
    };
  }

  // ---------- guardado ----------

  validar() {
    const vivas = this.state.filas.filter((fila) => !fila._eliminado);
    const keysMalas = new Set();
    const problemas = [];

    const sinInsumo = vivas.filter((fila) => !fila.insumoId);
    sinInsumo.forEach((fila) => keysMalas.add(fila._key));
    if (sinInsumo.length) problemas.push(`${sinInsumo.length} renglón(es) sin insumo elegido`);

    // El masivo aplica la columna "Nombre para el Cliente" a TODAS las filas que se le
    // manden, así que un nombre vacío en cualquier fila viva rechaza su renglón
    const sinNombre = vivas.filter((fila) => fila.insumoId && !textoLimpio(fila.nombreAlternativo));
    sinNombre.forEach((fila) => keysMalas.add(fila._key));
    if (sinNombre.length) problemas.push(`${sinNombre.length} renglón(es) sin "Nombre para el cliente"`);

    // Un insumo repetido ya NO bloquea el guardado: el mismo insumo puede llevar varios
    // renglones (otra clave del cliente, otra presentación, otro precio de contrato). El
    // backend sólo descarta los renglones calcados, que es lo que manda un reintento.

    return { ok: problemas.length === 0, problemas, keysMalas };
  }

  limpiarAlta(fila) {
    const precio = estaVacio(fila.precio) ? undefined : Number(fila.precio);
    return {
      insumoId: fila.insumoId,
      equivalenciaId: fila.equivalenciaId,
      nombreAlternativo: textoLimpio(fila.nombreAlternativo),
      clave: textoLimpio(fila.clave) || undefined,
      presentacion: textoLimpio(fila.presentacion) || undefined,
      precio,
      unidadId: fila.unidadId || undefined,
      conversion: 1,
    };
  }

  // Se mandan los valores ACTUALES COMPLETOS de las 5 columnas, no sólo lo que cambió:
  // editarInsumosPersonalizadosClienteMasivo aplica cada columna de `columnas` a cada
  // renglón de `data`, así que mandar deltas pisaría campos de las otras filas.
  // Las cadenas vacías y los null son intencionales: el backend los traduce a $unset.
  limpiarEdicion(fila) {
    return {
      itemId: fila._id,
      nombreAlternativo: textoLimpio(fila.nombreAlternativo),
      clave: textoLimpio(fila.clave),
      precio: estaVacio(fila.precio) ? null : Number(fila.precio),
      unidadId: fila.unidadId || null,
      presentacion: textoLimpio(fila.presentacion),
    };
  }

  guardar = async () => {
    const { ok, problemas, keysMalas } = this.validar();
    if (!ok) {
      this.setState({ keysConError: keysMalas });
      message.warning(`No se puede guardar: ${problemas.join(", ")}.`);
      return;
    }

    const { filas } = this.state;
    const vivas = filas.filter((fila) => !fila._eliminado);
    const nuevas = vivas.filter((fila) => !fila._id);
    const editadas = vivas.filter((fila) => fila._id && this.filaModificada(fila));
    const borradas = filas.filter((fila) => fila._eliminado && fila._id);

    if (nuevas.length === 0 && editadas.length === 0 && borradas.length === 0) {
      message.info("No hay cambios que guardar");
      return;
    }
    if (nuevas.length > LIMITE_ALTAS_POR_ENVIO) {
      message.warning(`Máximo ${LIMITE_ALTAS_POR_ENVIO} altas por envío. Guarda por partes.`);
      return;
    }

    // Sólo se pregunta por lo que se va a escribir: un renglón viejo que siempre estuvo
    // sin precio no tiene por qué preguntar en cada guardado
    const sinPrecio = [...nuevas, ...editadas].filter((fila) => estaVacio(fila.precio)).length;
    if (sinPrecio > 0) {
      const continuar = await new Promise((resolve) => {
        Modal.confirm({
          title: "Renglones sin precio",
          content: `${sinPrecio} renglón(es) se guardarán sin precio. En esos, el cliente verá el precio de la lista general en vez de un precio de contrato.`,
          okText: "Continuar",
          cancelText: "Revisar",
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (!continuar) return;
    }

    this.setState({ guardando: true, erroresBackend: [], keysConError: new Set() });

    // La regla que ordena todo el manejo de fallas parciales:
    //  - si NADA alcanzó a escribirse, NO se recarga; la captura se queda intacta en
    //    pantalla y basta con volver a presionar Guardar (las 3 operaciones son
    //    idempotentes: el bulk deduplica, las ediciones mandan valores completos y el
    //    borrado es un $set de estado).
    //  - si YA se escribió algo, se recarga aunque un paso posterior falle: si no, los
    //    renglones nuevos seguirían viéndose como pendientes cuando en realidad ya
    //    están guardados, y el reintento devolvería un "se omitieron N" incomprensible.
    let algoSeGuardo = false;
    const abortar = async (aviso) => {
      if (aviso) message.warning(aviso);
      this.setState({ guardando: false });
      if (algoSeGuardo) await this.recargar();
    };

    try {
      // 1) ALTAS primero: si luego falla una edición, lo perdido es una edición
      // (rehacerla es teclear un dato), no un renglón entero recién capturado
      if (nuevas.length > 0) {
        const res = await axios.post(
          "insumosCliente/agregarInsumosPersonalizadosClienteBulk",
          {
            empresaId: this.props.empresaId,
            clienteId: this.state.clienteId,
            lista: nuevas.map((fila) => this.limpiarAlta(fila)),
          },
          { headers: this.props.headersToken }
        );
        if (res.data.success !== 2) {
          await abortar(res.data.message || "No se pudieron agregar los insumos nuevos");
          return;
        }
        algoSeGuardo = true;
        if (res.data.omitidos > 0) {
          message.warning(`Se agregaron ${res.data.agregados}; se omitieron ${res.data.omitidos}.`);
          if (Array.isArray(res.data.errores) && res.data.errores.length) {
            this.setState({
              erroresBackend: res.data.errores.map((error) => ({
                titulo: error.insumoId,
                motivo: error.motivo,
              })),
            });
          }
        }
      }

      // 2) EDICIONES
      if (editadas.length > 0) {
        const res = await axios.post(
          "insumosCliente/editarInsumosPersonalizadosClienteMasivo",
          {
            empresaId: this.props.empresaId,
            clienteId: this.state.clienteId,
            columnas: COLUMNAS_MASIVO,
            data: editadas.map((fila) => this.limpiarEdicion(fila)),
          },
          { headers: this.props.headersToken }
        );
        if (res.data.success !== 2) {
          await abortar(res.data.message || "No se pudieron guardar los cambios");
          return;
        }
        // El masivo es por renglón: los que no salieron en `errores` SÍ se guardaron,
        // así que se recarga para ver el estado real y se deja el detalle a la vista
        if (Array.isArray(res.data.errores) && res.data.errores.length) {
          const porId = new Map(editadas.map((fila) => [String(fila._id), fila]));
          const detalle = res.data.errores.map((error) => ({
            titulo: porId.get(String(error.itemId))?.nombreAlternativo || error.itemId,
            motivo: error.motivo,
          }));
          this.setState({ guardando: false });
          await this.recargar();
          this.setState({ erroresBackend: detalle });
          message.warning(`${detalle.length} renglón(es) no se pudieron guardar. Revisa el detalle y vuelve a capturarlos.`);
          return;
        }
        algoSeGuardo = true;
      }

      // 3) BORRADOS
      if (borradas.length > 0) {
        const res = await axios.post(
          "insumosCliente/eliminarInsumosPersonalizadosClienteMasivo",
          {
            empresaId: this.props.empresaId,
            clienteId: this.state.clienteId,
            itemIds: borradas.map((fila) => fila._id),
          },
          { headers: this.props.headersToken }
        );
        if (res.data.success !== 2) {
          message.warning(res.data.message || "Se guardaron los cambios, pero no se pudieron eliminar algunos renglones");
        }
      }

      message.success("Cambios guardados");
      this.setState({ guardando: false, archivosExcel: [] });
      await this.recargar();
    } catch (err) {
      console.log(err);
      this.setState({ guardando: false });
      message.error("Hubo un error al guardar. Vuelve a presionar Guardar: no se duplica nada.");
      // Misma regla: si un paso previo ya escribió, la tabla tiene que reflejarlo
      if (algoSeGuardo) await this.recargar();
    }
  };

  // ---------- Excel ----------

  descargarPlantilla = () => {
    this.setState({ descargandoPlantilla: true });
    const unidades = this.state.opcionesUnidades.map((u) => u.label).filter(Boolean);
    axios
      .post(
        "insumos/catalogoVentaParaPlantillaInsumosCliente",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        descargarPlantillaInsumosCliente(res.data.success === 2 ? res.data.catalogo : [], unidades);
      })
      .catch(() => {
        message.warning("No se pudo traer el catálogo para la plantilla; se descargó sin la hoja de referencia.");
        descargarPlantillaInsumosCliente(undefined, unidades);
      })
      .finally(() => this.setState({ descargandoPlantilla: false }));
  };

  onChangeArchivo = (e) => {
    if (!esArchivoExcel(e.file)) {
      message.error("El archivo debe ser un archivo de excel (.xlsx)");
      return;
    }
    this.setState({
      procesandoExcel: true,
      progresoExcel: 0,
      archivosExcel: [{ ...e.file, name: e.file.name, status: "uploading", response: "Cargando" }],
    });
    leerFilasExcelInsumosCliente(e.file)
      .then((filas) => this.resolverYAbsorber(filas, e.file))
      .catch((err) => {
        console.log(err);
        message.error("No se pudo leer el archivo");
        this.setState({ procesandoExcel: false, progresoExcel: null, archivosExcel: [] });
      });
  };

  async resolverYAbsorber(filasExcel, file) {
    const terminar = () =>
      this.setState({
        procesandoExcel: false,
        progresoExcel: null,
        archivosExcel: [{ ...file, name: file.name, status: "success" }],
      });

    if (filasExcel.length === 0) {
      message.warning("El archivo no tiene filas para procesar (falta la columna 'Nombre para el Cliente')");
      return terminar();
    }

    const unidadesPorTexto = new Map(
      this.state.opcionesUnidades.map((u) => [normalizar(u.label), u.value]).filter(([texto]) => texto)
    );
    const filasConUnidad = resolverUnidadesDeFilas(filasExcel, unidadesPorTexto);

    let resultados = [];
    let insumosPorId = new Map();
    const hayClaves = filasConUnidad.some((fila) => fila.claveInsumo);

    if (hayClaves) {
      try {
        for (let i = 0; i < filasConUnidad.length; i += LOTE_RESOLUCION_EXCEL) {
          const lote = filasConUnidad.slice(i, i + LOTE_RESOLUCION_EXCEL);
          const res = await axios.post(
            "insumos/resolverClavesInsumosVentaCompletoMasivo",
            {
              empresaId: this.props.empresaId,
              // clienteId va en null a proposito: con el clienteId, ese endpoint acota
              // la busqueda a los insumos que el cliente YA tiene, que es justo lo
              // contrario de lo que necesita una pantalla de captura
              clienteId: null,
              precioId: this.state.precioId || null,
              filas: lote.map((fila) => ({ clave: fila.claveInsumo, descripcion: fila.descripcionInsumo })),
            },
            { headers: this.props.headersToken }
          );
          if (res.data.success !== 2) throw new Error(res.data.message);
          resultados = resultados.concat(res.data.resultados || []);
          (res.data.insumos || []).forEach((insumo) => insumosPorId.set(String(insumo._id), insumo));
          this.setState({ progresoExcel: Math.round(Math.min(i + LOTE_RESOLUCION_EXCEL, filasConUnidad.length) / filasConUnidad.length * 100) });
        }
      } catch (err) {
        console.log(err);
        message.warning("No se pudieron buscar las claves de insumo. Los renglones se cargaron para elegir el insumo a mano.");
        resultados = [];
      }
    }

    this.absorber(filasConUnidad, resultados, insumosPorId);
    return terminar();
  }

  // Se calcula fuera de setState a proposito: crea keys (this.contadorFilas) y avisa por
  // message, y un updater de setState puede invocarse dos veces en StrictMode
  absorber(filasExcel, resultados, insumosPorId) {
    const filas = [...this.state.filas];
    // Indice por insumoId sobre los renglones vivos, para poder fusionar
    const posicionPorInsumo = new Map();
    filas.forEach((fila, indice) => {
      if (!fila._eliminado && fila.insumoId) posicionPorInsumo.set(String(fila.equivalenciaId || fila.insumoId), indice);
    });

    const nuevas = [];
    let actualizados = 0;
    let sinResolver = 0;
    const tomadosEnArchivo = new Set();

    filasExcel.forEach((filaExcel, indice) => {
      const resultado = resultados[indice];
      const valores = {
        _origen: "excel",
        nombreAlternativo: filaExcel.nombreAlternativo,
        clave: filaExcel.clave,
        presentacion: filaExcel.presentacion,
        precio: filaExcel.precio,
        unidadId: filaExcel.unidadId,
      };

      if (resultado?.estado === "ENCONTRADO" && resultado.insumoId) {
        const insumoId = String(resultado.insumoId);
        // El archivo puede traer el mismo insumo en varios renglones (el cliente le da
        // varias claves). El PRIMERO actualiza el renglón que ya estaba en la tabla; los
        // siguientes entran como renglones aparte en vez de descartarse.
        const yaVinoEnElArchivo = tomadosEnArchivo.has(insumoId);
        tomadosEnArchivo.add(insumoId);

        // El precio del archivo manda; el sugerido sólo llena si la celda venía vacía
        const precioArchivo = estaVacio(filaExcel.precio) ? undefined : filaExcel.precio;
        const posicion = yaVinoEnElArchivo ? undefined : posicionPorInsumo.get(insumoId);

        if (posicion !== undefined) {
          // Ya está en la tabla: se ACTUALIZA en vez de descartarse. Es el caso real de
          // "el cliente mandó su lista de precios del contrato actualizada"; marcarlo como
          // "ya configurado" y saltarlo (lo que hace la pestaña Subir Insumos, que sólo
          // puede INSERTAR) ignoraría en silencio justo los precios nuevos.
          const existente = filas[posicion];
          filas[posicion] = {
            ...existente,
            _origen: "excel",
            nombreAlternativo: estaVacio(filaExcel.nombreAlternativo) ? existente.nombreAlternativo : filaExcel.nombreAlternativo,
            clave: estaVacio(filaExcel.clave) ? existente.clave : filaExcel.clave,
            presentacion: estaVacio(filaExcel.presentacion) ? existente.presentacion : filaExcel.presentacion,
            unidadId: estaVacio(filaExcel.unidadId) ? existente.unidadId : filaExcel.unidadId,
            precio: precioArchivo !== undefined ? precioArchivo : (estaVacio(existente.precio) ? resultado.precioSugerido ?? undefined : existente.precio),
            _precioTocado: true,
          };
          actualizados += 1;
          return;
        }

        const insumo = insumosPorId.get(insumoId);
        if (insumo) {
          nuevas.push(this.construirFilaDesdeInsumo(insumo, valores));
        } else {
          nuevas.push({
            ...this.construirFilaVacia(valores),
            insumoId,
            precio: precioArchivo !== undefined ? precioArchivo : resultado.precioSugerido ?? undefined,
          });
        }
        return;
      }

      sinResolver += 1;
      nuevas.push({
        ...this.construirFilaVacia(valores),
        _estadoClave: resultado?.estado || (filaExcel.claveInsumo ? "NO_ENCONTRADO" : undefined),
        _candidatos: resultado?.candidatos || undefined,
        _claveExcel: filaExcel.claveInsumo,
      });
    });

    const finales = [...nuevas, ...filas];
    this.setState({ filas: finales, ...this.calcularIndices(finales) });

    const nuevasConInsumo = nuevas.length - sinResolver;
    message.info(
      `${filasExcel.length} renglón(es) del archivo: ${nuevasConInsumo} nuevo(s), ${actualizados} que actualizan insumos ya configurados, ${sinResolver} sin resolver.`
    );
  }

  construirFilaVacia(valores = {}) {
    return {
      _key: this.nuevaKey(),
      _id: undefined,
      _origen: valores._origen || "manual",
      insumoId: undefined,
      nombreAlternativo: valores.nombreAlternativo,
      clave: valores.clave,
      presentacion: valores.presentacion,
      precio: valores.precio,
      unidadId: valores.unidadId,
      conversion: 1,
      _precioTocado: !estaVacio(valores.precio),
    };
  }

  // ---------- render ----------

  celdaCambiada(fila, campo) {
    return this.camposCambiados(fila).includes(campo);
  }

  estiloCelda(fila, campo) {
    return this.celdaCambiada(fila, campo) ? { backgroundColor: "#fff3cd", borderRadius: 4 } : undefined;
  }

  renderCeldaInsumo(fila) {
    const { empresaId, headersToken } = this.props;
    const { identidadesRepetidas } = this.state;
    const etiqueta = fila._estadoClave && ETIQUETAS_ESTADO_CLAVE[fila._estadoClave];

    // Repetir un insumo está permitido (otra clave del cliente, otra presentación, otro
    // precio de contrato), pero tiene que verse cuáles renglones comparten insumo
    const identidad = fila.insumoId ? String(fila.equivalenciaId || fila.insumoId) : "";
    const tagRepetido = !fila._eliminado && identidad && identidadesRepetidas.has(identidad) && (
      <Tag color="gold" style={{ marginBottom: 2 }}>Insumo en varios renglones</Tag>
    );

    // Un renglón ya guardado no puede cambiar de insumo: ni el endpoint unitario ni el
    // masivo tocan insumoId. Se borra y se agrega otro.
    if (fila._id) {
      return (
        <div>
          {tagRepetido}
          <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{fila._descripcion || <Tag color="red">Insumo dado de baja</Tag>}</div>
          {fila._claveInterna && <div style={{ fontSize: 11, color: "#999" }}>{fila._claveInterna}</div>}
        </div>
      );
    }

    if (fila.insumoId && !fila._editandoInsumo) {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>
            {tagRepetido}
            <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{fila._descripcion}</div>
            {fila._claveInterna && <div style={{ fontSize: 11, color: "#999" }}>{fila._claveInterna}</div>}
          </div>
          <ButtonItem size="small" icon={<EditOutlined />} onClick={() => this.funciones.editarInsumo(fila._key)} />
        </div>
      );
    }

    // AMBIGUO: el resolvedor devuelve los candidatos, así que se eligen sin volver a buscar
    if (fila._estadoClave === "AMBIGUO" && fila._candidatos?.length) {
      return (
        <div>
          <Tag color={etiqueta?.color}>{etiqueta?.texto}</Tag>
          <SelectItem
            sinBorde
            width="100%"
            placeholder="Elegir insumo"
            onChange={(valor) => this.funciones.elegirCandidato(fila._key, valor)}
          >
            {fila._candidatos.map((candidato) => (
              <Option value={candidato._id} key={candidato._id}>
                {candidato.stringBuscar || `${candidato.clave} - ${candidato.descripcion}`}
              </Option>
            ))}
          </SelectItem>
        </div>
      );
    }

    const identidadFila = fila.equivalenciaId || fila.insumoId;
    return (
      <div>
        {tagRepetido}
        {etiqueta && (
          <Tag color={etiqueta.color} style={{ marginBottom: 2 }}>
            {etiqueta.texto}
            {fila._claveExcel ? `: ${fila._claveExcel}` : ""}
          </Tag>
        )}
        <SelectInsumosItem
          empresaId={empresaId}
          headersToken={headersToken}
          tiposInsumos="venta"
          sinBorde
          width="100%"
          placeholder="Buscar insumo"
          value={identidadFila}
          insumoPreCargado={identidadFila ? { _id: identidadFila, stringBuscar: fila._stringBuscar || fila._descripcion } : null}
          onChange={(valor, insumo) => this.funciones.onChangeInsumo(fila._key, valor, insumo)}
        />
      </div>
    );
  }

  columnas() {
    const { opcionesUnidades } = this.state;
    const { actualizarFila, alternarEliminada } = this.funciones;

    return [
      {
        title: "Insumo",
        dataIndex: "insumoId",
        key: "insumoId",
        width: 250,
        render: (_, fila) => this.renderCeldaInsumo(fila),
      },
      {
        title: "Nombre para el cliente",
        dataIndex: "nombreAlternativo",
        key: "nombreAlternativo",
        width: 210,
        render: (valor, fila) => (
          <InputItem
            sinBorde
            placeholder="Nombre para el cliente"
            value={valor}
            style={this.estiloCelda(fila, "nombreAlternativo")}
            onChange={(e) => actualizarFila(fila._key, { nombreAlternativo: e.target.value })}
          />
        ),
      },
      {
        title: "Clave Cliente",
        dataIndex: "clave",
        key: "clave",
        width: 120,
        render: (valor, fila) => (
          <InputItem
            sinBorde
            placeholder="Clave"
            value={valor}
            style={this.estiloCelda(fila, "clave")}
            onChange={(e) => actualizarFila(fila._key, { clave: e.target.value })}
          />
        ),
      },
      {
        title: "Precio de contrato",
        dataIndex: "precio",
        key: "precio",
        width: 140,
        render: (valor, fila) => (
          <div>
            <InputNumberItem
              dinero
              sinBorde
              placeholder="Precio"
              value={valor}
              style={this.estiloCelda(fila, "precio")}
              onChange={(nuevo) => actualizarFila(fila._key, { precio: nuevo, _precioTocado: true })}
            />
            {fila._sinPrecioLista && estaVacio(valor) && (
              <Tag color="gold" style={{ fontSize: 10, marginTop: 2 }}>Sin precio en lista</Tag>
            )}
            {/* Sólo cuando el contrato difiere de la lista: ahí es donde el dato sirve */}
            {!estaVacio(fila._precioLista) && !mismoNumero(valor, fila._precioLista) && (
              <div style={{ fontSize: 10, color: "#999" }}>Lista: {dineroDisabledMask(fila._precioLista)}</div>
            )}
          </div>
        ),
      },
      {
        title: "Presentación",
        dataIndex: "presentacion",
        key: "presentacion",
        width: 130,
        render: (valor, fila) => (
          <InputItem
            sinBorde
            placeholder="Ej. Caja 24 pz"
            value={valor}
            style={this.estiloCelda(fila, "presentacion")}
            onChange={(e) => actualizarFila(fila._key, { presentacion: e.target.value })}
          />
        ),
      },
      {
        title: "Unidad",
        dataIndex: "unidadId",
        key: "unidadId",
        width: 150,
        render: (valor, fila) => {
          const desconocida = valor && !opcionesUnidades.some((opcion) => String(opcion.value) === String(valor));
          return (
            <div>
              <SelectItem
                sinBorde
                allowClear
                width="100%"
                placeholder="Unidad SAT"
                value={desconocida ? undefined : valor}
                options={opcionesUnidades}
                // El filterOption por defecto de SelectItem lee option.children, que con
                // `options` no existe: sin esto el buscador no encuentra nada
                filterOption={(texto, opcion) => String(opcion?.label ?? "").toLowerCase().includes(texto.toLowerCase())}
                style={this.estiloCelda(fila, "unidadId")}
                onChange={(nuevo) => actualizarFila(fila._key, { unidadId: nuevo })}
              />
              {desconocida && <Tag color="red" style={{ fontSize: 10 }}>Unidad desconocida</Tag>}
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "accion",
        key: "accion",
        width: 60,
        render: (_, fila) => (
          <ButtonItem
            size="small"
            danger={!fila._eliminado}
            icon={fila._eliminado ? <UndoOutlined /> : <DeleteOutlined />}
            title={fila._eliminado ? "Deshacer" : "Eliminar"}
            onClick={() => alternarEliminada(fila._key)}
          />
        ),
      },
    ];
  }

  render() {
    const {
      loading,
      guardando,
      cliente,
      clienteNombre,
      filas,
      soloModificados,
      erroresBackend,
      keysConError,
      archivosExcel,
      procesandoExcel,
      progresoExcel,
      contado,
      precioId,
      listasPrecios,
      modalVariosVisible,
      descargandoPlantilla,
    } = this.state;

    const resumen = this.resumen();
    const listaActual = listasPrecios.find((lista) => String(lista._id) === String(precioId));
    const clienteSinFlag = cliente && !cliente.insumosXCliente;
    const listaCompartida = cliente?.insumosCompartidosDeClienteId;

    const visibles = soloModificados
      ? filas.filter((fila) => !fila._id || fila._eliminado || this.filaModificada(fila))
      : filas;

    return (
      <>
        <PageHeader
          onBack={this.atras}
          title="Captura de Insumos por Cliente"
          subTitle={clienteNombre}
          style={{ border: "1px solid rgba(0, 0, 0, 0.15)", backgroundColor: "white", borderRadius: 5, marginBottom: 10 }}
          extra={[
            <SelectItem
              key="contado"
              width={190}
              value={contado}
              noBuscar
              onChange={this.onChangeContado}
            >
              <Option value={1}>Lista de Contado</Option>
              <Option value={2}>Lista de Crédito</Option>
            </SelectItem>,
            <ButtonItem
              key="plantilla"
              icon={<DownloadOutlined />}
              verde
              loading={descargandoPlantilla}
              onClick={this.descargarPlantilla}
            >
              Plantilla
            </ButtonItem>,
            <Upload
              key="excel"
              showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
              fileList={archivosExcel}
              customRequest={this.onChangeArchivo}
              accept=".xlsx"
              maxCount={1}
            >
              <ButtonItem icon={<UploadOutlined />} cyan>Cargar de Excel</ButtonItem>
            </Upload>,
            <ButtonItem key="varios" icon={<PlusOutlined />} onClick={() => this.setState({ modalVariosVisible: true })}>
              Agregar varios
            </ButtonItem>,
            <ButtonItem
              key="guardar"
              type="primary"
              icon={<SaveOutlined />}
              loading={guardando}
              disabled={clienteSinFlag}
              onClick={this.guardar}
            >
              Guardar
            </ButtonItem>,
          ]}
        />

        <Spin spinning={loading || guardando || procesandoExcel}>
          <div style={{ backgroundColor: "white", padding: 16, borderRadius: 5, border: "1px solid rgba(0, 0, 0, 0.15)" }}>
            {clienteSinFlag && (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 10 }}
                message='Este cliente no tiene activado "Insumos x Cliente"'
                description={
                  // El prop `action` de Alert no existe en antd 4.15.6 (llegó en 4.19),
                  // así que el botón va dentro de la descripción o no se pinta
                  <div>
                    <p style={{ marginBottom: 8 }}>
                      Mientras esté apagado, lo que captures aquí no se usará en sus ventas, pedidos ni
                      cotizaciones. Actívalo en Clientes &gt; Editar Cliente &gt; pestaña Insumos.
                    </p>
                    <ButtonItem size="small" onClick={this.atras}>
                      Ir al cliente
                    </ButtonItem>
                  </div>
                }
              />
            )}

            {listaCompartida && (
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 10 }}
                message="Estos insumos son de la lista de otro cliente"
                description="Lo que agregues, edites o borres aquí se guarda en la lista de ese cliente, y afecta a todos los que la comparten."
              />
            )}

            {!precioId && cliente && (
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 10 }}
                message="Este cliente no tiene lista de precios asignada"
                description="Los renglones nuevos van a llegar sin precio; captúralo a mano o asígnale una lista en Editar Cliente."
              />
            )}

            {erroresBackend.length > 0 && (
              <Alert
                type="error"
                showIcon
                style={{ marginBottom: 10 }}
                message={`${erroresBackend.length} renglón(es) no se guardaron`}
                description={
                  <div style={{ maxHeight: 160, overflowY: "auto" }}>
                    {erroresBackend.map((error, indice) => (
                      <div key={indice}>
                        <b>{error.titulo}:</b> {error.motivo}
                      </div>
                    ))}
                  </div>
                }
              />
            )}

            {procesandoExcel && progresoExcel !== null && (
              <Progress percent={progresoExcel} status="active" style={{ marginBottom: 10 }} />
            )}

            <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 12, flexWrap: "wrap" }}>
              <div style={{ flex: "1 1 320px", minWidth: 260 }}>
                <SelectInsumosItem
                  // El key remonta el buscador tras cada alta: limpia el texto escrito y
                  // deja el foco listo para el siguiente insumo. Va por la cantidad de
                  // renglones y no por los insumos distintos, porque el mismo insumo puede
                  // agregarse varias veces y el buscador igual tiene que limpiarse.
                  key={`buscador-${filas.length}`}
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  tiposInsumos="venta"
                  width="100%"
                  autoFocus
                  filtrarPorCategorias
                  placeholder="Buscar un insumo para agregarlo a la lista…"
                  value={undefined}
                  onChange={this.agregarFilaDesdeInsumo}
                />
              </div>
              <Switch
                checked={soloModificados}
                onChange={(valor) => this.setState({ soloModificados: valor })}
                checkedChildren="Sólo cambios"
                unCheckedChildren="Todos"
              />
              <Tag color="cyan">{resumen.total} en la lista</Tag>
              {resumen.nuevas > 0 && <Tag color="green">{resumen.nuevas} nuevo(s)</Tag>}
              {resumen.editadas > 0 && <Tag color="gold">{resumen.editadas} modificado(s)</Tag>}
              {resumen.eliminadas > 0 && <Tag color="red">{resumen.eliminadas} por eliminar</Tag>}
              {resumen.sinInsumo > 0 && (
                <ButtonItem size="small" danger onClick={this.quitarSinInsumo}>
                  Quitar {resumen.sinInsumo} sin insumo
                </ButtonItem>
              )}
              {listaActual && <span style={{ color: "#888" }}>Precios de: {listaActual.nombre}</span>}
            </div>

            <TableItem
              size="small"
              dataSource={visibles}
              columns={this.columnas()}
              rowKey={(fila) => fila._key}
              defaultPageSize={25}
              rowClassName={(fila) => {
                if (keysConError.has(fila._key)) return "revisar";
                if (fila._eliminado) return "baja-importancia";
                return "";
              }}
            />

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
              <ButtonItem
                type="primary"
                icon={<SaveOutlined />}
                loading={guardando}
                disabled={clienteSinFlag}
                onClick={this.guardar}
              >
                Guardar
              </ButtonItem>
            </div>
          </div>
        </Spin>

        <ModalSeleccionMultipleInsumos
          visible={modalVariosVisible}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          onCancelar={() => this.setState({ modalVariosVisible: false })}
          onAceptar={this.agregarVarios}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  insumosXCliente: state.empresa.insumosXCliente,
});

export default connect(mapStateToProps)(CapturaInsumosCliente);
